export enum LicenseStatus {
  Unknown = 0,
  Available,
  Assigned,
  Expired,
  NotFound,
  StoreDisabled
}
